import { resources } from "@constants/hardcoded-strings";
import { FormattedEmailTemplate } from "@idw-types/data/email-template";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { useMemo } from "react";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";

type EmailTemplateSelectFormGroupProps = BaseSelectFormGroupProps & {
    emailTemplates: Array<FormattedEmailTemplate>
};

export const EmailTemplateSelectFormGroup = (props: EmailTemplateSelectFormGroupProps) => {
    const { emailTemplates, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const emailTemplateOptions = useMemo(() => {
        return mapEntitiesWithNameAndIdToSelectOptions(emailTemplates);
    }, [emailTemplates]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-email-template-select`}
            label={resources.common.inputs.emailTemplate.label}
            ariaLabel={resources.common.inputs.emailTemplate.label}
            automationId={`${idPrefix}-email-template-select`}
            onChange={onChange}
            options={emailTemplateOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};